import React, { useState } from 'react';

const TrademarkRegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Trademark Registration.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Trademark registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Trademark Registration
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Protect your brand identity with exclusive legal rights. Our experts ensure a smooth trademark registration process from search to certificate issuance.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">📈</span> Protect Your Brand Identity
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Trademark Registration
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Trademark Registration in India protects your brand identity by granting exclusive rights to use your mark—including logos, brand names, slogans, and designs—in connection with your goods or services.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Registered trademarks provide legal protection against unauthorized use, enhance brand recognition, and increase the commercial value of your business. The registration process is governed under the Trade Marks Act, 1999, and carried out by the Intellectual Property India office.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                A registered trademark is valid for 10 years and can be renewed indefinitely, making it a valuable long-term asset for your business.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Exclusive Legal Rights:</strong> Protect your brand from infringement and unauthorized use.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Brand Recognition:</strong> Strengthen your market presence with a legally recognized identity.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Use of ® Symbol:</strong> Indicates a registered trademark, deterring imitators.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Government Protection:</strong> Access legal remedies including injunctions, damages, and account of profits.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Market Expansion:</strong> Facilitate exports and licensing by establishing internationally recognized brand ownership.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Asset Creation:</strong> Adds tangible value to your business as an intellectual property asset.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Renewable Registration:</strong> Valid for 10 years, with indefinite renewals.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Multi-Class Applications:</strong> Cover several classes of goods/services under a single application.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Trademark Registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Trademark Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "🔍", title: "Trademark Search", desc: "Conduct a thorough search to check mark availability and avoid conflicts with existing trademarks." },
              { number: "02", icon: "📄", title: "Application Filing", desc: "File the trademark application (form TM-A) with the required documents and fees through the IP India portal." },
              { number: "03", icon: "✅", title: "Acknowledgment", desc: "Receive application number for tracking and monitoring the status of your trademark application." },
              { number: "04", icon: "📋", title: "Examination", desc: "Trademark office examines application for compliance and potential conflicts with existing marks." },
              { number: "05", icon: "💬", title: "Response to Office Actions", desc: "Address any objections or queries raised by the examiner through proper documentation and arguments." },
              { number: "06", icon: "📖", title: "Publication", desc: "Trademark is published in the Trademark Journal for 4 months to invite oppositions from the public." },
              { number: "07", icon: "⚖️", title: "Opposition Handling", desc: "If opposition is filed, represent and provide evidence during hearings to defend your trademark." },
              { number: "08", icon: "🏆", title: "Registration Certificate", desc: "On acceptance, registration certificate is issued with official seal, granting exclusive rights for 10 years." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Trademark Registration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "👤", title: "For Individuals", desc: "Identity Proof (Aadhaar, Passport, Voter ID), Address Proof, Logo or mark representation (if applicable)" },
              { icon: "🏢", title: "For Companies/Entities", desc: "Certificate of Incorporation or Partnership Deed, Board Resolution/Power of Attorney, Identity proof of authorized signatory" },
              { icon: "🎨", title: "Trademark Design", desc: "Clear representation of your trademark/logo in JPEG/PNG format with proper specifications." },
              { icon: "📝", title: "User Affidavit", desc: "If the trademark is already in use, a user affidavit verifying usage details and date of first use." },
              { icon: "💳", title: "Payment Details", desc: "Payment receipt of government fees for trademark application filing." },
              { icon: "📁", title: "Additional Documents", desc: "Any other supporting documents as required based on the specific nature of your trademark application." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "📜", title: "Official Registration Certificate", desc: "Official Trademark Registration Certificate with registration number and government seal." },
              { icon: "📖", title: "Trademark Journal Publication", desc: "Copy of Trademark Journal publication where your mark was published for opposition." },
              { icon: "🔍", title: "Application Tracking Details", desc: "Complete acknowledgment and tracking details for monitoring your application status throughout the process." },
              { icon: "⚖️", title: "Legal Advisory Support", desc: "Comprehensive legal advisory on trademark enforcement, opposition proceedings, and future renewals." },
              { icon: "📞", title: "Ongoing Support", desc: "Opposition hearing representation, renewal reminders and assistance, trademark monitoring services, legal documentation support, brand protection guidance" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      Trademark FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">How long does trademark registration take?</h4>
                      <p className="text-gray-600">Generally, 12 to 24 months assuming no oppositions or objections. The timeline can vary based on the complexity of the application and any objections raised during examination.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">Can I use ™ symbol before registration?</h4>
                      <p className="text-gray-600">Yes, ™ indicates a claim to trademark rights but ® can only be used after official registration with the trademark office.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">Can trademarks be renewed?</h4>
                      <p className="text-gray-600">Yes, trademarks can be renewed every 10 years indefinitely by paying renewal fees to maintain protection.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">What if someone opposes my trademark?</h4>
                      <p className="text-gray-600">Both parties get a chance to present evidence and legal arguments before the Registrar. We provide representation and support throughout opposition proceedings.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">Is online filing available?</h4>
                      <p className="text-gray-600">Yes, applications can be conveniently filed on the IP India portal, and we handle the entire online filing process for you.</p>
                  </div>
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready to Register Your Trademark?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Protect your brand identity with our comprehensive trademark registration services. From search to certificate, we handle it all.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default TrademarkRegistration;